// removed by extract-text-webpack-plugin
module.exports = {"contact-button":"tiWd7pM9","contactButton":"tiWd7pM9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactButton/ContactButton.pcss
// module id = 380
// module chunks = 0